import React from 'react';
import { motion } from 'framer-motion';
import { Eye, GitMerge, FileText, ArrowDown, ArrowRight, Clock } from 'lucide-react';
export function ContentPreview() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-21">
          <div className="inline-flex items-center gap-2 bg-[#f0f9ff] text-[#0369a1] px-4 py-1.5 rounded-full text-sm font-medium mb-4" data-id="element-22">
            <Eye className="w-4 h-4" data-id="element-23" />
            Vista Previa
          </div>
          <h2 className="font-serif text-3xl md:text-4xl text-[#0f172a] mb-3" data-id="element-24">
            Mira Lo Que Recibes
          </h2>
          <p className="text-[#64748b] text-lg max-w-lg mx-auto" data-id="element-25">
            Así se ve por dentro. Diseñado para leer en 10 segundos a las 2AM.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-26">
          {/* Decision Tree Preview */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-27">
            <div className="bg-[#faf7f2] rounded-2xl border border-[#e2e8f0] p-6 md:p-8 shadow-lg" data-id="element-28">
              <div className="flex items-center gap-2 mb-6" data-id="element-29">
                <GitMerge className="w-5 h-5 text-[#5b8a7a]" data-id="element-30" />
                <span className="font-serif text-lg font-medium text-[#0f172a]" data-id="element-31">
                  Árbol de Decisión 2AM
                </span>
              </div>

              {/* Mini decision tree visualization */}
              <div className="flex flex-col items-center gap-3" data-id="element-32">
                <div className="bg-[#0f172a] text-white text-xs font-medium px-4 py-2 rounded-lg text-center w-full max-w-[200px]" data-id="element-33">
                  Bebé despierta 😢
                </div>
                <ArrowDown className="w-4 h-4 text-[#94a3b8]" data-id="element-34" />
                <div className="bg-[#5b8a7a] text-white text-xs font-medium px-4 py-2 rounded-lg text-center w-full max-w-[220px]" data-id="element-35">
                  Guion Base · 90 seg
                </div>
                <ArrowDown className="w-4 h-4 text-[#94a3b8]" data-id="element-36" />
                <div className="flex flex-wrap justify-center gap-2" data-id="element-37">
                  {['Hambre', 'Pañal', 'Gases', 'Contacto', 'Transfer.'].map((route, i) => <div key={i} className="bg-white border border-[#e2e8f0] text-[#475569] text-[10px] font-medium px-2.5 py-1.5 rounded-md shadow-sm" data-id="element-38">
                        {String.fromCharCode(65 + i)}: {route}
                      </div>)}
                </div>
                <ArrowDown className="w-4 h-4 text-[#94a3b8]" data-id="element-39" />
                <div className="flex items-center gap-1.5 bg-[#fef3c7] text-[#92400e] text-xs font-medium px-3 py-1.5 rounded-lg" data-id="element-40">
                  <Clock className="w-3 h-3" data-id="element-41" />
                  8–12 min → evaluar
                </div>
              </div>

              <p className="text-[#94a3b8] text-xs text-center mt-6 italic" data-id="element-42">
                1 página · imprimible · mesa de noche
              </p>
            </div>
          </motion.div>

          {/* Script Preview */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-43">
            <div className="bg-[#faf7f2] rounded-2xl border border-[#e2e8f0] p-6 md:p-8 shadow-lg" data-id="element-44">
              <div className="flex items-center gap-2 mb-6" data-id="element-45">
                <FileText className="w-5 h-5 text-[#e8856c]" data-id="element-46" />
                <span className="font-serif text-lg font-medium text-[#0f172a]" data-id="element-47">
                  Guion: Ruta A — Hambre
                </span>
              </div>

              {/* Script-like content */}
              <div className="space-y-4" data-id="element-48">
                <div className="flex items-start gap-3" data-id="element-49">
                  <div className="w-6 h-6 rounded-full bg-[#5b8a7a] text-white text-xs flex items-center justify-center shrink-0 mt-0.5 font-bold" data-id="element-50">
                    1
                  </div>
                  <div data-id="element-51">
                    <p className="text-[#0f172a] text-sm font-medium" data-id="element-52">
                      Observa señales
                    </p>
                    <p className="text-[#64748b] text-xs mt-0.5" data-id="element-53">
                      Boqueo, manos a la boca, giro de cabeza
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-54">
                  <div className="w-6 h-6 rounded-full bg-[#5b8a7a] text-white text-xs flex items-center justify-center shrink-0 mt-0.5 font-bold" data-id="element-55">
                    2
                  </div>
                  <div data-id="element-56">
                    <p className="text-[#0f172a] text-sm font-medium" data-id="element-57">
                      Ofrece toma en calma
                    </p>
                    <p className="text-[#64748b] text-xs mt-0.5" data-id="element-58">
                      Luz mínima · sin hablar · posición cómoda
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-59">
                  <div className="w-6 h-6 rounded-full bg-[#5b8a7a] text-white text-xs flex items-center justify-center shrink-0 mt-0.5 font-bold" data-id="element-60">
                    3
                  </div>
                  <div data-id="element-61">
                    <p className="text-[#0f172a] text-sm font-medium" data-id="element-62">
                      Eructo suave
                    </p>
                    <p className="text-[#64748b] text-xs mt-0.5" data-id="element-63">
                      2–3 min máx · no forzar
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 opacity-40" data-id="element-64">
                  <div className="w-6 h-6 rounded-full bg-[#94a3b8] text-white text-xs flex items-center justify-center shrink-0 mt-0.5 font-bold" data-id="element-65">
                    4
                  </div>
                  <div data-id="element-66">
                    <p className="text-[#0f172a] text-sm font-medium" data-id="element-67">
                      Transferencia...
                    </p>
                    <p className="text-[#64748b] text-xs mt-0.5" data-id="element-68">
                      ••••••••••••
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-4 border-t border-[#e2e8f0] flex items-center justify-between" data-id="element-69">
                <p className="text-[#94a3b8] text-xs italic" data-id="element-70">
                  Vista previa · Ruta A de 5
                </p>
                <div className="flex items-center gap-1 text-[#e8856c] text-xs font-medium" data-id="element-71">
                  Ver todo <ArrowRight className="w-3 h-3" data-id="element-72" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}